import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.padding !== 0)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: _normalizeClass(["border inline-block border-red-500 text-red-600 bg-red-200 dark:border-red-900 dark:text-dark-text dark:bg-red-900", `${_ctx.textSize}`]),
        style: _normalizeStyle(`padding: ${_ctx.padding}px; 
    border-radius: ${_ctx.border_radius}rem;`)
      }, _toDisplayString(_ctx.text), 7))
    : (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: _normalizeClass(["border inline-block border-red-500 text-red-600 bg-red-200 dark:border-red-900 dark:text-dark-text dark:bg-red-900", `${_ctx.textSize}`]),
        style: _normalizeStyle(`padding: ${_ctx.padding_top}px ${_ctx.padding_right}px ${_ctx.padding_bottom}px ${_ctx.padding_left}px; 
    border-radius: ${_ctx.border_radius}rem;`)
      }, _toDisplayString(_ctx.text), 7))
}